<div class="flex flex-1 flex-col" [formGroup]="aboutForm">
<div class="mb-8 flex justify-center">
  <img
    src="assets/icons/mortarboard.svg"
    alt="Ilustração de curso"
    class="h-44 w-auto object-contain"
  />
</div>

<div class="flex flex-1 flex-col gap-6">
  <div class="grid grid-cols-1 gap-5 lg:grid-cols-3">
    <div class="flex min-w-0 flex-col gap-2">
      <label for="courseName" class="text-sm font-medium text-lGray500">
        Curso <span class="text-lDanger">*</span>
      </label>
      <div class="relative">
        <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-xl text-lGray600">school</l-icon>
        <input
          id="courseName"
          type="text"
          formControlName="title"
          required
          lInput
          class="border-none pl-11 rounded-xl"
          placeholder="A arte da gestão de pessoas"
        />
      </div>
    </div>

    <div class="flex min-w-0 flex-col gap-2">
      <label for="courseCategory" class="text-sm font-medium text-lGray500">
        Categoria <span class="text-lDanger">*</span>
      </label>
      <div class="relative">
        <l-icon class="pointer-events-none absolute left-4 top-1/2 z-10 -translate-y-1/2 text-xl text-lGray600">grid_view</l-icon>
        <p-select
          inputId="courseCategory"
          [options]="categories"
          formControlName="categoryId"
          optionValue="id"
          optionLabel="name"
          placeholder="Selecione uma categoria"
          class="w-full [&_.p-select-label]:pl-11 [&_.p-select-label.p-placeholder]:text-lGray600"
        />
      </div>
    </div>

    <div class="flex min-w-0 flex-col gap-2">
      <label for="courseDuration" class="text-sm font-medium text-lGray500">Tempo de duração (horas)</label>
      <div class="relative">
        <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-xl text-lGray600">schedule</l-icon>
        <input
          id="courseDuration"
          type="text"
          inputmode="decimal"
          formControlName="duration"
          lInput
          lDecimalInput
          class="border-none pl-11 rounded-xl"
          placeholder="ex: 12, 0.5, 4.5, etc."
        />
      </div>
    </div>
  </div>

  <div class="grid grid-cols-1 gap-5 lg:grid-cols-2">
    <div class="flex min-w-0 flex-col gap-2">
      <label for="courseType" class="text-sm font-medium text-lGray500">Tipo</label>
      <p-select
        inputId="courseType"
        [options]="typeOptions"
        formControlName="type"
        optionValue="value"
        optionLabel="label"
        placeholder="Selecione o tipo"
        class="w-full"
      />
    </div>

    <div class="flex min-w-0 flex-col gap-2">
      <label for="courseLocation" class="text-sm font-medium text-lGray500">Localidade</label>
      <p-select
        inputId="courseLocation"
        [options]="locationOptions"
        formControlName="location"
        optionValue="value"
        optionLabel="label"
        placeholder="Selecione a localidade"
        class="w-full"
      />
    </div>
  </div>

  <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
    <div class="min-w-0">
      <span class="mb-2 block text-sm font-medium text-lGray500">
        Capa do curso <span class="text-lDanger">*</span>
      </span>
      <l-cover-image-upload
        urlInputId="courseCoverUrl"
        fileInputId="courseCoverFile"
        [(imageUrl)]="imageUrl"
        (previewStateChange)="onCoverPreviewState($event)"
        (previewSrcChange)="onCoverPreviewSrcChange($event)"
        (imageFileChange)="onCoverFileChange($event)"
      />
    </div>

    <div class="min-w-0">
      <label for="courseSearchTags" class="mb-2 block text-sm font-medium text-lGray500">Tags de pesquisa</label>
      <l-tag-select inputId="courseSearchTags" formControlName="tags" />
    </div>
  </div>

  <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
    <div class="flex min-w-0 flex-col gap-2">
      <label for="courseShortDescription" class="text-sm font-medium text-lGray500">Descrição curta</label>
      <div class="relative">
        <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-xl text-lGray600">format_align_left</l-icon>
        <input
          id="courseShortDescription"
          type="text"
          formControlName="shortDescription"
          maxlength="80"
          lInput
          class="border-none pl-11 rounded-xl"
          placeholder="Descreva brevemente o curso"
        />
      </div>
    </div>

    <div class="min-w-0">
      <span class="mb-2 block text-sm font-medium text-lGray500">Descrição detalhada</span>
      <div class="relative flex w-full flex-col">
        <textarea
          formControlName="detailedDescription"
          maxlength="250"
          placeholder="Descreva aqui os detalhes do curso"
          class="min-h-32 w-full resize-y rounded-xl border-none bg-lGray950 px-4 py-3 text-base text-color placeholder:text-lGray600 focus:border-lPrimary focus:outline-none focus:ring-1 focus:ring-lPrimary disabled:cursor-not-allowed disabled:opacity-60"
        ></textarea>
        <div class="pointer-events-none absolute bottom-3 right-3 text-xs text-lSecondary">
          {{ aboutForm.controls.detailedDescription.value.length }} / 250
        </div>
      </div>
    </div>
  </div>

  <p class="text-xs text-lDanger">(*) Campos obrigatórios</p>
</div>
</div>
